import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { OtpService } from "../services/otp.service";
import { ToastrService } from "ngx-toastr";
import { Response } from "../shared/models";
import { NgOtpInputComponent, NgOtpInputConfig } from "ng-otp-input";
import { GlobalVariable } from "src/app/app.component";

@Component({
  selector: "app-email-verification",
  templateUrl: "./email-verification.component.html",
  styleUrls: ["./email-verification.component.scss"],
})
export class EmailVerificationComponent implements OnInit {
  private globalVar = GlobalVariable;

  @ViewChild(NgOtpInputComponent, { static: false })
  ngOtpInput: NgOtpInputComponent;
  private BASE_URL = GlobalVariable;

  loading: boolean = false;
  resendClicked: boolean = false;
  resendError: boolean = false;
  resendErrorMessage: string = "";
  userEmail: string = "";
  userPhone: string;
  disableResend: boolean = false;
  disableSubmit: boolean = true;
  attemptsLeft: number;
  otp: number;
  otpTyped: boolean = false;
  otpConfig: NgOtpInputConfig = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: "",
    inputClass: "otp-input",
  };
  show_error_message: String;
  isForgetPassword: boolean = false;
  isEmailLoginType: boolean = false;
  loginUserName: string;
  loginType: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private otpService: OtpService,
    private router: Router
  ) {}

  ngOnInit(): void {
    let qParams;
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      qParams = { ...params.keys, ...params };
    });
    if (qParams?.action) {
      this.isForgetPassword = qParams.action == "forget-password";
    }
    if (qParams?.loginType) {
      this.loginType = qParams?.loginType;

      if (this.loginType == this.BASE_URL.loginType.mobile) {
        this.userPhone = qParams?.user_login;
      } else {
        this.userEmail = qParams?.user_login;
      }
    }
    if (qParams?.user_login) {
      this.loginUserName = qParams?.user_login;
    }
    this.generateOtp(true);
  }

  generateOtp(isFirstTime = false) {
    if (this.disableResend) {
      return;
    }
    this.loading = true;
    let res: Response;

    let url;
    if (this.isForgetPassword) {
      let payload = {
        username: this.loginUserName,
      };
      url = this.otpService.forgetPassword(payload);
    } else {
      let payload = {
        username: this.loginUserName
      };
      url = this.otpService.triggerOtp(payload);
    }

    url.subscribe(
      (data: Response) => {
        res = data;
        this.loading = false;
        if (res && res.code === 201) {
          this.loading = false;
          this.resendError = false;
          this.resendErrorMessage = "";
          this.show_error_message = "";
          if (!isFirstTime) {
            this.resendClicked = true;
          } else {
            this.ngOtpInput.setValue("");
          }
          this.attemptsLeft = res.val.attempts_left;
          if (this.attemptsLeft <= 0) {
            this.attemptsLeft = 0;
            this.disableResend = true;
          }
        }
      },
      (error) => {
        this.loading = false;
        if (error?.error?.message) {
          this.show_error_message = error.error.message;
          this.resendError = true;
          this.resendErrorMessage = error.error.message;
        }
      }
    );
  }

  bannerClose(data) {
    this.resendClicked = false;
  }

  errorBannerClose(data) {
    this.resendError = false;
    this.resendErrorMessage = "";
  }

  otpChange(e) {
    this.otpTyped = true;
    this.otp = e;
    this.disableSubmit =
      this.otp && this.otp.toString().length === 6 ? false : true;
    if (this.otp && this.otp.toString().length === 6 && e.keyCode === 13) {
      this.onSubmit();
    }
  }

  onSubmit() {
    let res: Response;
    let payload = {
      username: this.loginUserName,
      otp: this.otp.toString(),
    };
    this.otpService.verifyOtpV3(payload).subscribe(
      (data: Response) => {
        res = data;
        if (res && res.code === 202) {
          let hasPassword = res.val.has_password;
          if (res.val.is_phone_verify_allowed && !res.val.is_phone_verified) {
            console.error("verify this /mobile-otp page is valid");
            this.router.navigate(["/signin/mobile-otp"], {
              queryParams: {
                phone: this.loginUserName,
                login_user: this.loginUserName,
                reset_token: res.val.reset_token
              },
            });
          } else {
            this.router.navigate(["/signin/create-password"], {
              queryParams: {
                reset_token: res.val.reset_token,
                has_password: hasPassword
              },
            });
          }
          this.resendError = false;
          this.resendErrorMessage = "";
        } else {
          if (res) {
            this.resendError = false;
            this.resendErrorMessage = "";
          }
        }
      },
      (error) => {
        this.resendError = true;
        this.resendErrorMessage = error.error.message;
      }
    );
  }
}
